// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_M_9NB {
  padding: 8px 18px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease;
  white-space: nowrap;
  line-height: 1.5;
}

.primary_TaUJR {
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  border-color: var(--_10a37f-background);
}

.primary_TaUJR:hover {
  background-color: #008a8a;
  border-color: #008a8a;
}

.secondary_SwF2p {
  background-color: var(--white-background);
  color: #555;
  border: 1px solid var(--d9-background);
}

.secondary_SwF2p:hover {
  border-color: #00a3a3;
  color: #00a3a3;
}

.button_M_9NB:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;mBACiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".button {\n  padding: 8px 18px;\n  border-radius: 6px;\n  border: 1px solid transparent;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease,\n    color 0.2s ease;\n  white-space: nowrap;\n  line-height: 1.5;\n}\n\n.primary {\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  border-color: var(--_10a37f-background);\n}\n\n.primary:hover {\n  background-color: #008a8a;\n  border-color: #008a8a;\n}\n\n.secondary {\n  background-color: var(--white-background);\n  color: #555;\n  border: 1px solid var(--d9-background);\n}\n\n.secondary:hover {\n  border-color: #00a3a3;\n  color: #00a3a3;\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_M_9NB`,
	"primary": `primary_TaUJR`,
	"secondary": `secondary_SwF2p`
};
export default ___CSS_LOADER_EXPORT___;
